import React from "react";
import { string } from "prop-types";

import * as S from "./styled";

const FormHeader = ({
  ariaContentDescribedBy,
  ariaContentLabelledBy,
  className
}) => (
  <div className={className}>
    <S.Title id={ariaContentLabelledBy}>Contact This Agent</S.Title>
    <S.SubTitle data-qa="expert-match-drawer-title" id={ariaContentDescribedBy}>
      Say hello to find out how their expertise in this neighborhood and price
      point can help you sell.
    </S.SubTitle>
  </div>
);

FormHeader.propTypes = {
  ariaContentDescribedBy: string,
  ariaContentLabelledBy: string,
  className: string
};

FormHeader.defaultProps = {
  ariaContentDescribedBy: null,
  ariaContentLabelledBy: null,
  className: null
};

export default FormHeader;
